import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors } from '@angular/forms';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../app.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StripeService, StripeCardComponent, Element as StripeElement, ElementOptions, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { Location } from '@angular/common'

@Component({
    selector: 'app-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.css']
})

export class PaymentMethodsComponent implements OnInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    error: any;
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
    cardOptions: ElementOptions = {
        style: {
            base: {
                iconColor: '#276fd3',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                color: '#A9A9A9'
                }
            },
            invalid: {
                color: '#C12127',
                iconColor: '#C12127'
            }
        }
    };
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    elementsOptions: ElementsOptions = {
        locale: localStorage.getItem('language')=="es"?'es':'en'
    };

    formSubmitted: boolean = false;
   
    cardList:any;
    cardInfo:any;
    email:any;

    loading = false;
    confirmation;

    clicked = false;
    submitted = false;
    formProcess = false;
    message = "";
    addCardForm = this.formBuilder.group({
        CardName: ['', [Validators.required, Validators.maxLength(26), Validators.pattern(AppConstants.cardNameRegex)]],
        BillingAddress: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        BillingCity: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingState: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCountry: ['', [Validators.required, Validators.maxLength(75), Validators.pattern(AppConstants.addressRegex)]]
    });

    constructor(
        private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        private location: Location,
        public router: Router, 
        private modalService: NgbModal,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private breadcrumbService: BreadcrumbService,
        private route: ActivatedRoute,
        private _stripe: StripeService){
            translate.setDefaultLang('en');
            this.functionsService.setTitle('account.payment-methods');
        } 

    ngOnInit(){
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.translate.onLangChange.subscribe(() => {
            if(this.error){
                this.error["message"] = "";
            }
            this.elementsOptions = {
                locale: (localStorage.getItem('language')=='es')?'es':'en'
            };
        });
        this.breadcrumbService.set('payment-methods', 'Edit Company');
        this.spinner.show();
        this.getPaymentMethods();
    }

    getPaymentMethods(){
        this.apiService.getPaymentMethods().subscribe(
            data => {
                this.cardList = data;
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    addCard(){
        if (!this.addCardForm.valid) {
            this.formSubmitted = true;
            return;
        } 
        this.clicked = true;
        Object.keys(this.addCardForm.controls).forEach((key)=>{
          this.addCardForm.value[key] = this.addCardForm.value[key]?this.addCardForm.value[key].trim():"";})
        //
        this._stripe
            .createToken(this.card.getCard(), { 
                name: this.addCardForm.value["CardName"], 
                address_line1: this.addCardForm.value["BillingAddress"],
                address_city: this.addCardForm.value["BillingCity"],
                address_state: this.addCardForm.value["BillingState"],
                address_country: this.addCardForm.value["BillingCountry"],
                currency: "USD"
            })
            .subscribe(result => {
                if (result.token)
                {
                    this.spinner.show();
                    //Create body content
                    var content:Object = {};
                    content["Result"] = result.token;
                    
                    this.apiService.addCard(content).subscribe(
                        data => {
                            this.addCardForm.reset();
                            this.formSubmitted = false;
                            this.clicked = false;
                            this.card.getCard().clear();
                            this.card.error = null;
                            this.getPaymentMethods();
                        },
                        error => {
                            this.clicked = false;
                            this.functionsService.errorHandler(error["status"]);
                            this.spinner.hide();
                        }
                    );
                } else if (result.error) {
                    // Error creating the token
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                    modalRef.componentInstance.message = result.error.message;
                    this.translate.onLangChange.subscribe(() => {
                        modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                    });
                    this.spinner.hide();
                }
            });
    }

    deleteCard(card){
        const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
        confirmModalRef.componentInstance.title = this.translate.instant('account.delete_card');
        confirmModalRef.componentInstance.message = this.translate.instant('account.delete_card_prompt')+`${card.last4}?`;
        confirmModalRef.result.then(confirmed => {
            if (confirmed) {
                this.spinner.show();
                this.apiService.deleteCard(card.id).subscribe(
                    data => {
                        this.getPaymentMethods();
                    },
                    error => {
                        this.spinner.hide();
                        const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                        modalRef.componentInstance.title = "Error";
                        modalRef.componentInstance.message = error["error"]["content"];
                    }
                );
            }
        });
    }

    setAsPreferred(card){
        const expiry = new Date(card.exp_year, card.exp_month);
        const current = new Date();
        if(expiry.getTime() < current.getTime()){
            //Card is expired, throw error message
            const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = "Error";
                    modalRef.componentInstance.message = this.translate.instant("account.set_preferred_err");
                    this.translate.onLangChange.subscribe(() => {
                        if(modalRef.componentInstance){
                            modalRef.componentInstance.message = this.translate.instant("account.set_preferred_err");
                        }
                    });
            return;
        }
        this.spinner.show();
        this.apiService.changePreferredCard(card).subscribe(
            () => {
                this.getPaymentMethods();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    cardUpdated(result) {
        this.element = result.element;
        this.complete = result.card.complete;
        this.error = undefined;
    }

    cancelAdd(){
        this.location.back();
    }

    controlGetter(controlName) {
        const control =  this.addCardForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    get CardName() { return this.controlGetter('CardName'); }
    get BillingAddress() { return this.controlGetter('BillingAddress'); }
    get BillingCity() { return this.controlGetter('BillingCity'); }
    get BillingState() { return this.controlGetter('BillingState'); }
    get BillingCountry() { return this.controlGetter('BillingCountry'); }
}